// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"settingsPaymentMeanCreateView_form-wrapper__1VjIY"};